import { useEffect, useState } from "react";

import "../CSS/links.css";

import API_URL from "../apiConfig";


function LinkPage() {

    const [links, setLinks] = useState([]);

    const [isLoading, setIsLoading] = useState(true);

    const [error, setError] = useState("");


    useEffect(() => {

        async function loadLinks() {

            try {

                const response =
                    await fetch(
                        `${API_URL}/links.php`
                    );

                if (!response.ok) {
                    throw new Error(
                        "Links konnten nicht geladen werden."
                    );
                }

                const data =
                    await response.json();

                setLinks(
                    data
                        .filter(
                            (link) =>
                                Number(link.aktiv) === 1
                        )
                        .sort(
                            (a, b) =>
                                Number(a.reihenfolge) - Number(b.reihenfolge) ||
                                Number(a.id) - Number(b.id)
                        )
                );

            }
            catch (error) {

                console.error(
                    error
                );

                setError(
                    "Die Links konnten nicht geladen werden."
                );

            }
            finally {

                setIsLoading(
                    false
                );

            }

        }


        loadLinks();

    }, []);


    return (
        <>

            <div className="intro">

                <h1>
                    Empfehlungen und Links
                </h1>

                <p>
                    Folgende Webseiten und Links kann ich euch empfehlen:
                </p>

            </div>


            <main className="links-main">

                <section className="empfehlungen">

                    {isLoading && (

                        <p>
                            Links werden geladen...
                        </p>

                    )}


                    {!isLoading && error && (

                        <p>
                            {error}
                        </p>

                    )}


                    {!isLoading &&
                        !error &&
                        links.map(
                            (link) => (

                                <div
                                    className="linkbox"
                                    key={link.id}
                                >

                                    {link.bild && (

                                        <img
                                            src={`/Fotos/${link.bild}`}
                                            alt={link.name}
                                        />

                                    )}


                                    <h3>
                                        {link.name}
                                    </h3>


                                    <p>
                                        {link.beschreibung}
                                    </p>


                                    <a
                                        href={link.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        Webseite öffnen
                                    </a>

                                </div>

                            )
                        )
                    }

                </section>

            </main>

        </>
    );
}


export default LinkPage;